import React, { useEffect, useState } from 'react'
import { Notice as Styled } from './style'
import { getNoticeHeader } from 'apis/message'

const Notice = () => {
  const [data, setData] = useState<any>(undefined)
  useEffect(() => {
    getNoticeHeader().then((e) => {
      setData(e)
    })
  }, [])
  return (
    data && (
      <Styled>
        <div className='right'>
          {/* <span> ✿ 자타공인 타업체 비교불가</span>
            <span> 최고배당 </span>
            <span>으로 인정받은 </span>
            <span> SMAPLE!! </span>
            <span> 방문을 환영합니다 </span>
            <span> ✿ 지인추천 더블UP 이벤트진행중~♬ </span>
            <span> ✿ 스포츠 단폴배팅 500만원 축배팅당첨 3천만원~♬ ✿</span> */}
          <div className='marquee'>
            <div className='box'>
              <span className='span'>{data.siteMgs}</span>
            </div>
          </div>
        </div>
      </Styled>
    )
  )
}

export default Notice
